/**
 * Home's Updates tab: newest first, split into To review (open) and Reviewed
 * (folded) while there are both.
 *
 * @module components/home/HomeUpdatesList
 */
import type { HomeGlance } from "./homeGlance.logic";
import { HomeListEmpty } from "./HomeListEmpty";
import { HomeSplitList } from "./HomeSplitList";
import { updateList } from "./homeTabs.logic";
import { HomeUpdateRow } from "./HomeUpdateRow";

export function HomeUpdatesList({
  glance,
  orgSegment,
  now,
}: {
  readonly glance: HomeGlance;
  readonly orgSegment: string;
  readonly now: number;
}) {
  if (glance.updates.length === 0) return <HomeListEmpty>No publications yet</HomeListEmpty>;
  return (
    <HomeSplitList
      list={updateList(glance)}
      labels={{ needsHand: "To review", rest: "Reviewed" }}
      row={(update) => <HomeUpdateRow key={update.id} update={update} orgSegment={orgSegment} now={now} />}
    />
  );
}
